/**
 * 複写する受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const orders_accepts_duplicate_order = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit }, { conditions, page }) {
      const params = {
        ...conditions,
        sort_type: 'updated',
        page: page
      }
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/orders/accepts/duplicate_orders`, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default orders_accepts_duplicate_order
